import { MarkPublishOrder } from './vo/mark-publish-order.model'

/**
 * マーク掲載順設定画面の値を管理するクラス
 *
 * @export KYMW1505Model
 * @class KYMW1505Model
 */
export class KYMW1505Model {

  public markGroupList = [];
  public selectedMarkGroup = '';
  public beforeChangeSelectedMarkGroup = '';
  public markListMap = {};
  public displayMarkList = []
  public beforeChangeMarkList = [];

  /**
   * マークグループリストを更新する
   *
   * @param serverData マークグループリストのサーバ取得データ
   */
  public updateMarkGroupList(serverData: any) {
    this.markGroupList = serverData;
  }

  /**
   * マーク掲載順VO生成
   *
   * @param mark マーク
   */
  private newVo(mark: any) {
    return new MarkPublishOrder(
      mark.MarkGroupCode,
      mark.MarkCode,
      mark.MarkName,
      mark.PublishOrder,
      mark.MarkFileUrl,
    )
  }

  /**
   * マーク掲載順リストを更新する
   *
   * @param serverData マーク掲載順リストのサーバ取得データ
   */
  public updateMarkListMap(serverData: any) {
    // グループコンボボックス変更時に取り出しやすいよう整形しておく
    // {グループコード: [マーク, ...]}
    for (const data of serverData) {
      const mark = this.newVo(data);
      if (mark.markGroupCode in this.markListMap) {
        this.markListMap[mark.markGroupCode].push(mark);
      } else {
        this.markListMap[mark.markGroupCode] = [mark];
      }
    }

    // 掲載順でソートする
    for (const key in this.markListMap) {
      this.markListMap[key].sort((a, b) => {
        return Number(a.publishOrder) > Number(b.publishOrder) ? 1 : -1;
      })
    }
  }
}
